import type { IPositionable } from "~/models/IUserEntry";

export default function useSortEntries<T extends IPositionable[]>(
  entries: Ref<T>
) {
  return computed(() => {
    return [...entries.value].sort((a, b) =>
      a.position.node_start_id !== b.position.node_start_id
        ? a.position.node_start_id - b.position.node_start_id
        : a.position.word_start_offset - b.position.word_start_offset
    );
  });
}
